import * as React from 'react';
const ReflussoGastroesofageoIcon = ({
  primaryColor,
  secondaryColor,
  width,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M95.39 100c-1.82 4.56-5.69 8.34-10.41 9.63-6.73 1.84-14.5-.86-20.55 2.63-4.57 2.64-6.79 8.27-6.8 13.58-.02 5.31 1.34 9.16 3.13 14.16M85.69 52c-2.67 3.32-3.62 9.26-2.7 13.76"
      className="prefix__cls-2"
    />
    <path
      d="M120.26 62.51c4.93.41 10.02 2.34 13.86 5.5 8.72 7.16 9.55 18.06 6.94 28.51 0 0-6.21 33.4-34.32 39.2-5.17 1.07-10.57.88-15.4-1.19-3.91-1.67-7-4.45-9.76-7.62-1.15-1.33-2.37-2.69-3.98-3.37-1.84-.77-4.08-.49-5.67.71-2.7 2.04-2.73 5.98-1.9 8.97.64 2.29 2.03 4.71 3.19 6.78M96.38 52c-1.01 1.23-1.92 2.97-2.46 4.78"
      className="prefix__cls-2"
    />
    <circle cx={102.47} cy={78.51} r={8.66} className="prefix__cls-1" />
    <circle cx={102.47} cy={78.51} r={1.24} className="prefix__cls-1" />
    <circle cx={102.47} cy={78.51} r={16.14} className="prefix__cls-1" />
  </svg>
);
export default ReflussoGastroesofageoIcon;
